<template>
  <div>
    <v-bottom-sheet
      v-model="visible"
      hide-overlay
      :persistent="true"
    >
      <div class="bg-white">
        <div class="d-flex align-center px-5 py-2">
          <div class="text--secondary">
            {{$t('attachments.file')}}
          </div>
          <v-spacer></v-spacer>
          <v-btn
            fab
            small
            elevation="2"
            color="white"
            @click="hide()"
          >
            <Icon
              :width="24"
              :color="'rgba(0,0,0,.54)'"
              :icon="'close'"
            />
          </v-btn>
        </div>
        <v-slide-y-transition>
          <FilePreview
            ref="file-preview"
            v-if="preview"
            :base64="preview.base64"
            :file="preview.file"
            @clear="clear"
            @setAttachment="setAttachment"
          />
          <UploadOptions
            ref="upload-options"
            class="options"
            v-else
            @setPreview="setPreview"
          />
        </v-slide-y-transition>
      </div>
    </v-bottom-sheet>
  </div>
</template>

<script>
/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator'

@Component({
  components: {
    UploadOptions: () => import(/* webpackPrefetch: true */ '@/views/session/components/chat/resources/attachments/resources/UploadOptions.vue'),
    FilePreview: () => import(/* webpackPrefetch: true */ '@/views/session/components/chat/resources/attachments/resources/FilePreview.vue'),
    Icon: () => import(/* webpackPrefetch: true */ '@/components/Icon.vue')
  }
})
export default class Index extends Vue {
  data () {
    return {
      visible: false,
      preview: null,
      attachment: null
    }
  }

  setAttachment (attachment) {
    this.attachment = attachment
    this.$emit('sendAttachment', attachment)
  }

  setPreview (preview, file) {
    this.preview = {
      base64: preview,
      file
    }
  }

  clear () {
    this.preview = null
    this.attachment = null
    if (this.$refs['upload-options']) {
      this.$refs['upload-options'].clear()
    }
  }

  show () {
    this.visible = true
  }

  hide () {
    this.visible = false
  }

  toggle () {
    this.visible = !this.visible
  }
}
</script>

<style>
.br-top-2 {
  -webkit-border-top-left-radius: 10px;
  -webkit-border-top-right-radius: 10px;
  -moz-border-radius-topleft: 10px;
  -moz-border-radius-topright: 10px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
</style>
